export enum ApiSyncPayloadTypeEnum{
    START_DOWNSTREAM,
    START_UPSTREAM,
    CONTINUE_DOWNSTREAM,
    CONTINUE_UPSTREAM,
    FINISH_DOWNSTREAM,
    FINISH_UPSTREAM,
    STORE,
    VALIDATE_LOCAL_RECORD,
    VALIDATE_MULTIPLE_LOCAL_RECORDS,
    ABORT_DOWNSTREAM,
    ABORT_UPSTREAM,
    ABORT_ANY,
    BUSY,
    OTHER
}